import { useState, type FormEvent } from 'react'
import { Button, Input } from '@/components/ui'
import { trpc } from '@/lib/trpc'

/**
 * Selbstregistrierung eines neuen Betriebs (M8 / SaaS). Legt Organisation +
 * Inhaber-Konto an und meldet direkt an. Nur sichtbar, wenn die Instanz
 * `SIGNUP_ENABLED` gesetzt hat.
 */
export function Register({ onSuccess, onBack }: { onSuccess: () => void; onBack: () => void }) {
  const [orgName, setOrgName] = useState('')
  const [legalForm, setLegalForm] = useState('GmbH')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const signup = trpc.auth.signup.useMutation({ onSuccess })

  const submit = (e: FormEvent) => {
    e.preventDefault()
    signup.mutate({ orgName, legalForm, email, password })
  }

  return (
    <div className="h-full flex items-center justify-center bg-bg-primary">
      <form onSubmit={submit} className="card p-6 w-80 space-y-4">
        <div className="flex items-center gap-2">
          <div className="w-7 h-7 rounded-md bg-accent flex items-center justify-center">
            <span className="text-white text-sm font-bold leading-none">M</span>
          </div>
          <div>
            <p className="text-sm font-semibold text-text-primary leading-none">Mavatech CRM</p>
            <p className="text-2xs text-text-tertiary leading-none mt-0.5">Betrieb registrieren</p>
          </div>
        </div>
        <Input
          label="Firmenwortlaut"
          value={orgName}
          onChange={(e) => setOrgName(e.target.value)}
          required
          minLength={2}
        />
        <Input label="Rechtsform" value={legalForm} onChange={(e) => setLegalForm(e.target.value)} />
        <Input
          label="E-Mail"
          type="email"
          autoComplete="username"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <Input
          label="Passwort (min. 8 Zeichen)"
          type="password"
          autoComplete="new-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          minLength={8}
        />
        {signup.error && <p className="text-xs text-danger">{signup.error.message}</p>}
        <Button type="submit" variant="primary" className="w-full" loading={signup.isPending}>
          Registrieren
        </Button>
        <button
          type="button"
          onClick={onBack}
          className="w-full text-xs text-text-tertiary hover:text-text-secondary"
        >
          Zurück zur Anmeldung
        </button>
      </form>
    </div>
  )
}
